import React from "react";

const OPTIONS = [
  { value: "agent", icon: "⚡", label: "Agent", desc: "Automates tasks & navigates the app" },
  { value: "chat",  icon: "💬", label: "Chat",  desc: "Ask questions & get instant answers" },
];

export function ModePicker({ mode, setMode }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const current = OPTIONS.find(o => o.value === mode) || OPTIONS[0];

  return (
    <div ref={ref} style={MP.wrap}>
      {open && (
        <div style={MP.menu}>
          {OPTIONS.map(opt => (
            <button
              key={opt.value}
              style={{ ...MP.menuItem, ...(mode === opt.value ? MP.menuItemActive : {}) }}
              onClick={() => { setMode(opt.value); setOpen(false); }}
            >
              <span style={MP.menuIcon}>{opt.icon}</span>
              <span style={MP.menuText}>
                <span style={MP.menuLabel}>{opt.label}</span>
                <span style={MP.menuDesc}>{opt.desc}</span>
              </span>
              {mode === opt.value && <span style={MP.menuCheck}>✓</span>}
            </button>
          ))}
        </div>
      )}
      <button style={MP.trigger} onClick={() => setOpen(o => !o)}>
        <span style={MP.triggerIcon}>{current.icon}</span>
        <span style={MP.triggerLabel}>{current.label}</span>
        <svg
          style={{ ...MP.chevron, transform: open ? "rotate(180deg)" : "none" }}
          width="11" height="11" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
    </div>
  );
}

const MP = {
  wrap: { position: "relative", marginTop: 7, marginBottom: 7 },
  trigger: {
    display: "inline-flex", alignItems: "center", gap: 5,
    background: "rgba(99,102,241,0.07)", border: "1px solid rgba(99,102,241,0.18)",
    borderRadius: 8, padding: "4px 10px", cursor: "pointer",
    fontSize: 12, fontWeight: 500, color: "#4f46e5",
    transition: "background 0.15s", userSelect: "none",
  },
  triggerIcon:  { fontSize: 13 },
  triggerLabel: { fontSize: 12, fontWeight: 600 },
  chevron: { color: "#6366f1", flexShrink: 0, transition: "transform 0.2s" },
  menu: {
    position: "absolute", bottom: "calc(100% + 6px)", left: 0,
    background: "#ffffff", border: "1px solid #e2e8f0",
    borderRadius: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(99,102,241,0.1)",
    overflow: "hidden", zIndex: 99999,
    minWidth: 220,
    animation: "ai-fadeIn 0.12s ease",
  },
  menuItem: {
    width: "100%", display: "flex", alignItems: "center", gap: 10,
    padding: "10px 14px", background: "none", border: "none",
    cursor: "pointer", textAlign: "left",
    borderBottom: "1px solid #f1f5f9",
    transition: "background 0.12s",
  },
  menuItemActive: { background: "rgba(99,102,241,0.06)" },
  menuIcon:  { fontSize: 18, flexShrink: 0 },
  menuText:  { display: "flex", flexDirection: "column", flex: 1 },
  menuLabel: { fontSize: 13, fontWeight: 600, color: "#1e293b", lineHeight: 1.3 },
  menuDesc:  { fontSize: 11, color: "#94a3b8", marginTop: 1, lineHeight: 1.3 },
  menuCheck: { color: "#6366f1", fontWeight: 700, fontSize: 13, flexShrink: 0 },
};
